export enum ContentBadge {
  NEW = 'NEW',
  ORIGINAL = 'ORIGINAL',
  ONLY = 'ONLY',
  UP = 'UP',
  COMPLETED = 'COMPLETED',
  PUBLISHED = 'PUBLISHED',
  PICK_CHOOSE = 'PICK_CHOOSE',
  ADULT = 'ADULT',
  HIDE_RESERVE = 'HIDE_RESERVE',
  HIDDEN = 'HIDDEN',
  UNCONTRACTED = 'UNCONTRACTED',
}

export const BADGE_EXCLUDES: Partial<Record<ContentBadge, ContentBadge>> = {
  [ContentBadge.ORIGINAL]: ContentBadge.ONLY,
  [ContentBadge.ONLY]: ContentBadge.ORIGINAL,
  [ContentBadge.COMPLETED]: ContentBadge.PUBLISHED,
  [ContentBadge.PUBLISHED]: ContentBadge.COMPLETED,
  [ContentBadge.HIDE_RESERVE]: ContentBadge.HIDDEN,
  [ContentBadge.HIDDEN]: ContentBadge.HIDE_RESERVE,
};

export enum BadgePosition {
  TOP_LEFT = 'TOP_LEFT',
  TOP_RIGHT = 'TOP_RIGHT',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  INLINE = 'INLINE',
}

export enum BadgeMode {
  COVER = 'COVER',
  ADULT_ONLY = 'ADULT_ONLY',
  TEXT = 'TEXT',
}

export const MODE_LAYOUT: Record<BadgeMode, Partial<Record<BadgePosition, ContentBadge[]>>> = {
  [BadgeMode.COVER]: {
    [BadgePosition.TOP_LEFT]: [
      ContentBadge.NEW,
      ContentBadge.ORIGINAL,
      ContentBadge.ONLY,
      ContentBadge.UP,
      ContentBadge.COMPLETED,
      ContentBadge.PUBLISHED,
      ContentBadge.PICK_CHOOSE,
    ],
    [BadgePosition.TOP_RIGHT]: [ContentBadge.ADULT],
    [BadgePosition.BOTTOM_LEFT]: [ContentBadge.UNCONTRACTED],
    [BadgePosition.BOTTOM_RIGHT]: [ContentBadge.HIDE_RESERVE, ContentBadge.HIDDEN],
  },
  [BadgeMode.ADULT_ONLY]: {
    [BadgePosition.TOP_RIGHT]: [ContentBadge.ADULT],
  },
  [BadgeMode.TEXT]: {
    [BadgePosition.INLINE]: [
      ContentBadge.NEW,
      ContentBadge.ORIGINAL,
      ContentBadge.ONLY,
      ContentBadge.UP,
      ContentBadge.COMPLETED,
      ContentBadge.PUBLISHED,
      ContentBadge.PICK_CHOOSE,
      ContentBadge.ADULT,
      ContentBadge.HIDE_RESERVE,
      ContentBadge.HIDDEN,
      ContentBadge.UNCONTRACTED,
    ],
  },
};

export type BadgesByPosition = Partial<Record<BadgePosition, ContentBadge[]>>;

export interface ContentBadgeState {
  badgesByPosition: BadgesByPosition;
}
